import { Controller } from "@hotwired/stimulus"

// Send-to-SAP modal: disable buttons while POST runs, then full navigation (redirect or reload).
export default class extends Controller {
  static targets = ["submit", "cancel", "spinner", "label"]
  static values = {
    loadingText: { type: String, default: "Sending…" }
  }

  connect() {
    if (this.hasLabelTarget) {
      this.defaultLabelText = this.labelTarget.textContent
    }
  }

  async submit(event) {
    const form = event.target
    if (!(form instanceof HTMLFormElement) || !form.action) return

    event.preventDefault()
    event.stopPropagation()

    if (this._busy) return
    this._busy = true

    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")

    this.submitTarget.disabled = true
    if (this.hasCancelTarget) this.cancelTarget.disabled = true
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("hidden")
    if (this.hasLabelTarget) this.labelTarget.textContent = this.loadingTextValue

    const dialog = this.element.closest('[data-confirm-modal-target="dialog"]')
    if (dialog) dialog.setAttribute("aria-busy", "true")

    try {
      const res = await fetch(form.action, {
        method: "POST",
        body: new FormData(form),
        credentials: "same-origin",
        redirect: "manual",
        headers: {
          "X-CSRF-Token": token || "",
          Accept: "text/html",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (res.status === 302 || res.status === 303) {
        const loc = res.headers.get("Location")
        if (loc) {
          window.location.assign(loc)
          return
        }
      }

      if (res.ok) {
        window.location.reload()
        return
      }

      window.location.reload()
    } catch (_e) {
      this._busy = false
      this.submitTarget.disabled = false
      if (this.hasCancelTarget) this.cancelTarget.disabled = false
      if (this.hasSpinnerTarget) this.spinnerTarget.classList.add("hidden")
      if (this.hasLabelTarget) this.labelTarget.textContent = this.defaultLabelText || ""
      if (dialog) dialog.removeAttribute("aria-busy")
      window.alert("Could not send to SAP. Check your connection and try again.")
    }
  }
}
